import React, { useEffect } from 'react'
import useStyles from './style'
import { Grid } from '@mui/material'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
// import required modules
import { Navigation, Pagination, Autoplay } from 'swiper'
import { API_ENDPOINTS } from 'constants'
import _ from 'lodash'

const list = [
  { id: 1, img: '/assets/images/slider/1.jpg' },
  { id: 2, img: '/assets/images/slider/2.jpg' },
  { id: 3, img: '/assets/images/slider/3.jpg' },
  { id: 4, img: '/assets/images/slider/4.jpg' },
  { id: 5, img: '/assets/images/slider/5.jpg' },
]

const Slider = (props) => {
  const { sliderProcess } = props
  const classes = useStyles()

  const handleBannerNaviagtion = (data) => {
    window.open(
      `/shop/${data?.category_id?.name?.toLowerCase()}/${
        data?.subCategory_id?.name
          ? data?.subCategory_id?.name?.toLowerCase()
          : ''
      }?ocassion=${
        data?.productstyle?.occasion?.name
          ? data?.productstyle?.occasion?.name
          : ''
      }&weight=${
        data?.weightRange?.range ? data?.weightRange?.range : ''
      }&gender=${
        data?.productstyle?.gender?.gendername
          ? data?.productstyle?.gender?.gendername
          : ''
      }&productStyle=${
        data?.productstyle?.name ? data?.productstyle?.name : ''
      }`,
      '_self'
    )
  }

  useEffect(() => {
    const handlePopstate = () => {
      // Handle back button functionality here
      // You can perform any necessary actions or navigate to the previous screen
    }

    window.addEventListener('popstate', handlePopstate)

    return () => {
      window.removeEventListener('popstate', handlePopstate)
    }
  }, [])

  return (
    <>
      {!_.isEmpty(sliderProcess) ? (
        <Grid container>
          <Grid item xs={12}>
            <section className={classes.sliderWrapper}>
              <Swiper
                onInit={(swiper) => {
                  swiper.navigation.init()
                  swiper.navigation.update()
                }}
                slidesPerView={1}
                navigation={true}
                pagination={{
                  clickable: true,
                  type: 'bullets',
                }}
                modules={[Navigation, Pagination, Autoplay]}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false,
                }}
                grabCursor={true}
                loop={true}
                className="mySwiper"
              >
                {sliderProcess?.map((data) => (
                  <SwiperSlide key={data?.id}>
                    <div
                      className={classes.imgContainer}
                      onClick={() => handleBannerNaviagtion(data)}
                    >
                      <img
                        src={API_ENDPOINTS?.FILE_URL + data?.image}
                        alt={data?.label}
                        className={classes.img}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </section>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  )
}

export default Slider
